<script>
import { apiSecond } from '@/boot/axios'
import AqEmpty from '@/components/aqua/AqEmpty.vue'
import AqPageHeader from '@/components/aqua/AqPageHeader.vue'
import AqStatus from '@/components/aqua/AqStatus.vue'
import AquaSelect from '@/views/account/reporting/aqua/AquaSelect.vue'

export default {
	name: 'ZpmMy',
	components: {
		AqEmpty,
		AqPageHeader,
		AqStatus,
		AquaSelect,
	},
	data() {
		const statusOptions = [
			{ value: '', label: this.$t('filters.status_all') },
			{ value: 'active', label: this.$t('zpm.status_active') },
			{ value: 'inactive', label: this.$t('zpm.status_inactive') },
		]
		return {
			statusOptions,
			selectedStatus:
				statusOptions.find((o) => o.value === (this.$route.query.status || '')) || statusOptions[0],
			list: [],
			totals: 0,
			loading: false,
			filters: {
				zpm_nikad: this.$route.query.zpm_nikad || '',
			},
			errorMessage: {
				status: null,
				text: null,
			},
			options: {
				page: Number(this.$route?.query?.page || 1),
				itemsPerPage: Number(this.$route?.query?.per_page || 10),
			},
		}
	},
	computed: {
		query() {
			return this.$route.query
		},
		statusSelectOptions() {
			return this.statusOptions.map((option) => ({ value: option.value, text: option.label }))
		},
		pageCount() {
			return Math.max(1, Math.ceil(this.totals / this.options.itemsPerPage))
		},
		hasFilters() {
			return !!(this.$route.query.status || this.$route.query.zpm_nikad)
		},
	},
	watch: {
		query: {
			handler() {
				this.apiGetZpm()
			},
			immediate: true,
		},
		options: {
			handler(newOptions) {
				if (
					this.$route.query.page != newOptions.page ||
					this.$route.query.per_page != newOptions.itemsPerPage
				) {
					this.$router.replace({
						query: {
							...this.$route.query,
							page: newOptions.page,
							per_page: newOptions.itemsPerPage,
							filterTime: new Date().getTime(),
						},
					})
				}
			},
			deep: true,
		},
		'$route.query.page'(newPage) {
			if (newPage && this.options.page !== Number(newPage)) {
				this.options.page = Number(newPage)
			}
		},
		'$route.query.per_page'(newPerPage) {
			if (newPerPage && this.options.itemsPerPage !== Number(newPerPage)) {
				this.options.itemsPerPage = Number(newPerPage)
			}
		},
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
	methods: {
		onOptionsUpdate(newOptions) {
			this.options.page = newOptions.page
			this.options.itemsPerPage = newOptions.itemsPerPage
		},
		setStatus(value) {
			this.selectedStatus = this.statusOptions.find((option) => option.value === value) || this.statusOptions[0]
		},
		goPage(page) {
			this.options.page = Math.min(Math.max(1, page), this.pageCount)
		},
		remainderPercent(remainder, capacity) {
			const total = Number(capacity)
			if (!total) return 0
			return Math.round((Number(remainder || 0) / total) * 100)
		},
		formatNum(value) {
			if (value === null || value === undefined || value === '') return '—'
			const number = Number(value)
			return Number.isNaN(number) ? value : number.toLocaleString('ru-RU', { maximumFractionDigits: 3 })
		},
		cardLink(item) {
			return { path: '/' + this.$i18n.locale + '/account/zpm-my/' + item.id, query: { page: this.$route.query.page || 1 } }
		},
		statusLabel(status) {
			if (!status) return '-'
			const key = 'zpm.status_' + status
			return this.$te(key) ? this.$t(key) : status
		},
		formatDate(date) {
			if (!date) return '-'
			const parts = String(date).slice(0, 10).split('-')
			if (parts.length !== 3) return date
			return `${parts[2]}.${parts[1]}.${parts[0]}`
		},
		search() {
			this.$router.replace({
				query: {
					...this.$route.query,
					page: 1,
					zpm_nikad: this.filters.zpm_nikad || undefined,
					status: this.selectedStatus?.value || undefined,
					filterTime: new Date().getTime(),
				},
			})
		},
		resetFilters() {
			this.filters = { zpm_nikad: '' }
			this.selectedStatus = this.statusOptions[0]
			this.search()
		},
		catchError(error) {
			if (error?.response?.status == 500) {
				this.errorMessage.status = 500
				this.errorMessage.text = this.$t('system_message.500')
			}
			if (error?.response?.status == 401) {
				this.errorMessage.status = 401
				this.errorMessage.text = error.response.data.error_message
				this.$router.push('/' + this.$i18n.locale + '/login')
			}
			if (error?.response?.status == 422) {
				this.errorMessage.status = 422
				this.errorMessage.text = error.response.data.error_message
			}
			if (error?.response?.status == 403) {
				this.errorMessage.status = 403
				this.errorMessage.text = error?.response?.data?.message
			}
		},
		async apiGetZpm() {
			try {
				this.loading = true
				const params = {
					page: this.$route?.query?.page || 1,
					per_page: this.$route?.query?.per_page || 10,
				}
				if (this.$route.query.zpm_nikad) params.zpm_nikad = this.$route.query.zpm_nikad
				if (this.$route.query.status) params.status = this.$route.query.status

				const response = await apiSecond.get('v1/zpm/user-data', { params })

				// user-data возвращает { success, data: { data: [], total, ... } }
				const paginator = response?.data?.data
				if (paginator) {
					let rows = paginator.data || []
					// фильтрация по статусу/номеру на клиенте (бэк user-data их не фильтрует)
					if (this.$route.query.status) {
						rows = rows.filter((r) => r.status === this.$route.query.status)
					}
					if (this.$route.query.zpm_nikad) {
						const q = String(this.$route.query.zpm_nikad).toLowerCase()
						rows = rows.filter((r) => String(r.zpm_nikad || '').toLowerCase().includes(q))
					}
					const filterActive = this.$route.query.status || this.$route.query.zpm_nikad
					this.list = rows
					this.totals = filterActive ? rows.length : paginator.total || rows.length
				}
			} catch (error) {
				this.catchError(error)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<template>
	<div
		class="wrap__content aq-page"
		v-bind:class="{
			'wrap__content--preloader': !$store.state.userObject || !$store.getters.userPermission,
		}"
	>
		<v-preloader
			v-if="!$store.getters.userPermission || !$store.state.userObject"
			:message="errorMessage"
		></v-preloader>

		<div v-else class="container">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['ZpmMy']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content aq-shell">
							<AqPageHeader
								:title="$t('sidebar.zpm')"
								:eyebrow="$t('aqua.ui.grown.eyebrow')"
								:subtitle="$t('aqua.ui.zpm.my_hint')"
							/>

							<form class="aq-card aq-filters" @submit.prevent="search">
								<label class="aq-filters__field">
									<span>{{ $t('headers.zpm_nikad') }}</span>
									<input v-model="filters.zpm_nikad" type="text" name="filter_zpm_nikad" class="aq-input" />
								</label>
								<div class="aq-filters__field">
									<span>{{ $t('headers.status') }}</span>
									<AquaSelect :value="selectedStatus.value" :options="statusSelectOptions" @change="setStatus" />
								</div>
								<div class="aq-filters__actions">
									<button v-if="hasFilters" type="button" class="aq-btn aq-btn--ghost" @click.prevent.stop="resetFilters">
										{{ $t('button.clear') }}
									</button>
									<button type="submit" class="aq-btn aq-btn--primary">{{ $t('button.find') }}</button>
								</div>
							</form>

							<div v-if="loading && !list.length" class="aq-cards" aria-busy="true">
								<div v-for="n in 2" :key="n" class="aq-card aq-zpm aq-zpm--skeleton"></div>
							</div>

							<div v-else-if="list.length" class="aq-cards" :class="{ 'is-loading': loading }">
								<router-link v-for="item in list" :key="item.id" :to="cardLink(item)" class="aq-card aq-zpm">
									<header class="aq-zpm__head">
										<div class="aq-zpm__id">
											<span class="aq-zpm__label">{{ $t('headers.zpm_nikad') }}</span>
											<strong class="aq-zpm__code">{{ item.zpm_nikad || '—' }}</strong>
										</div>
										<AqStatus :value="item.status" :label="statusLabel(item.status)" />
									</header>
									<dl class="aq-zpm__facts">
										<div>
											<dt>{{ $t('zpm.period') }}</dt>
											<dd>{{ formatDate(item.start_date) }} — {{ formatDate(item.end_date) }}</dd>
										</div>
										<div v-if="item.activity_type_title || item.activity_type">
											<dt>{{ $t('zpm.activity_type') }}</dt>
											<dd>{{ ($i18n.locale === 'kz' && item.activity_type_title_kz) || item.activity_type_title || item.activity_type }}</dd>
										</div>
									</dl>
									<div class="aq-zpm__total">
										<div class="aq-zpm__total-row">
											<span>{{ $t('aqua.ui.zpm.remainder_total') }}</span>
											<span>
												<strong>{{ formatNum(item.total_remainder) }}</strong>
												/ {{ formatNum(item.total_capacity) }} {{ $t('aqua.ui.zpm.unit') }}
											</span>
										</div>
										<span class="aq-bar aq-bar--lg" role="progressbar" :aria-valuenow="remainderPercent(item.total_remainder, item.total_capacity)" aria-valuemin="0" aria-valuemax="100">
											<span :style="{ width: remainderPercent(item.total_remainder, item.total_capacity) + '%' }"></span>
										</span>
									</div>
									<ul v-if="item.fishes && item.fishes.length" class="aq-zpm__fishes">
										<li v-for="fish in item.fishes" :key="fish.id">
											<span class="aq-zpm__fish-name">{{ fish.fish_name }}</span>
											<span class="aq-zpm__fish-value">
												{{ formatNum(fish.remainder) }} / {{ formatNum(fish.design_capacity) }}
											</span>
											<span class="aq-bar" :class="{ 'aq-bar--low': remainderPercent(fish.remainder, fish.design_capacity) < 20 }">
												<span :style="{ width: remainderPercent(fish.remainder, fish.design_capacity) + '%' }"></span>
											</span>
										</li>
									</ul>
									<span class="aq-zpm__more">
										{{ $t('aqua.ui.zpm.open_card') }}
										<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
											<path d="M9 5l7 7-7 7" />
										</svg>
									</span>
								</router-link>
							</div>

							<div v-else class="aq-card">
								<AqEmpty
									:title="hasFilters ? $t('aqua.ui.zpm.empty_filtered') : $t('aqua.ui.zpm.my_empty_title')"
									:text="hasFilters ? $t('aqua.ui.zpm.empty_filtered_text') : $t('aqua.ui.zpm.my_empty_text')"
								>
									<button v-if="hasFilters" type="button" class="aq-btn" @click="resetFilters">{{ $t('button.clear') }}</button>
								</AqEmpty>
							</div>

							<nav v-if="pageCount > 1" class="aq-pager" :aria-label="$t('aqua.ui.zpm.pages')">
								<button type="button" class="aq-btn aq-btn--icon" :disabled="options.page <= 1" :aria-label="$t('aqua.ui.back')" @click="goPage(options.page - 1)">
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
										<path d="M15 5l-7 7 7 7" />
									</svg>
								</button>
								<span class="aq-pager__info">{{ options.page }} / {{ pageCount }}</span>
								<button type="button" class="aq-btn aq-btn--icon" :disabled="options.page >= pageCount" :aria-label="$t('aqua.ui.zpm.next')" @click="goPage(options.page + 1)">
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
										<path d="M9 5l7 7-7 7" />
									</svg>
								</button>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.aq-shell {
	background: var(--aq-bg);
}
.aq-filters {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	gap: 14px 16px;
	padding: 18px 24px;
}
.aq-filters__field {
	display: flex;
	flex: 1 1 220px;
	flex-direction: column;
	gap: 6px;
	max-width: 320px;
	margin: 0;
}
.aq-filters__field > span {
	color: var(--aq-ink-2);
	font-size: 13px;
	font-weight: 500;
}
.aq-filters__field ::v-deep .aqua-select {
	width: 100%;
}
.aq-filters__field ::v-deep .aqua-select__control {
	height: 44px;
	border-color: var(--aq-border-strong);
	border-radius: 10px;
}
.aq-filters__field ::v-deep .aqua-select__control:hover {
	border-color: var(--aq-primary);
}
.aq-filters__actions {
	display: flex;
	gap: 10px;
	margin-left: auto;
}
.aq-cards {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
	gap: 20px;
	transition: opacity 0.2s var(--aq-ease);
}
.aq-cards.is-loading {
	opacity: 0.6;
}
.aq-zpm {
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-bottom: 0;
	padding: 20px 22px;
	color: var(--aq-ink);
	text-decoration: none;
	transition: border-color 0.2s var(--aq-ease), box-shadow 0.2s var(--aq-ease), transform 0.2s var(--aq-ease);
}
.aq-zpm:hover {
	border-color: #b9d6f8;
	box-shadow: var(--aq-shadow-hover);
	color: var(--aq-ink);
}
.aq-zpm:focus-visible {
	outline: none;
	box-shadow: 0 0 0 3px rgba(21, 127, 238, 0.3);
}
.aq-zpm--skeleton {
	min-height: 280px;
	background: linear-gradient(90deg, #f1f5fb 0%, #f8fbff 50%, #f1f5fb 100%);
	background-size: 200% 100%;
	animation: aq-shimmer 1.4s linear infinite;
}
@keyframes aq-shimmer {
	from {
		background-position: 200% 0;
	}
	to {
		background-position: -200% 0;
	}
}
.aq-zpm__head {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
}
.aq-zpm__id {
	display: flex;
	flex-direction: column;
	gap: 2px;
}
.aq-zpm__label {
	color: var(--aq-muted);
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
}
.aq-zpm__code {
	font-family: ui-monospace, 'SFMono-Regular', Consolas, monospace;
	font-size: 18px;
	letter-spacing: 0.02em;
}
.aq-zpm__facts {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px 16px;
	margin: 0;
}
.aq-zpm__facts dt {
	color: var(--aq-muted);
	font-size: 12px;
	font-weight: 500;
}
.aq-zpm__facts dd {
	margin: 2px 0 0;
	font-size: 14px;
	font-weight: 500;
	line-height: 1.4;
}
.aq-zpm__total {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 14px 16px;
	border-radius: var(--aq-radius);
	background: var(--aq-bg);
}
.aq-zpm__total-row {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: 10px;
	color: var(--aq-muted);
	font-size: 13px;
}
.aq-zpm__total-row strong {
	color: var(--aq-ink);
	font-size: 20px;
}
.aq-zpm__fishes {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin: 0;
	padding: 0;
	list-style: none;
}
.aq-zpm__fishes li {
	display: grid;
	grid-template-columns: minmax(0, 1fr) auto;
	gap: 4px 12px;
	font-size: 13px;
}
.aq-zpm__fish-name {
	overflow: hidden;
	color: var(--aq-ink-2);
	text-overflow: ellipsis;
	white-space: nowrap;
}
.aq-zpm__fish-value {
	color: var(--aq-ink);
	font-weight: 600;
	white-space: nowrap;
}
.aq-zpm__fishes .aq-bar {
	grid-column: 1 / -1;
}
.aq-bar {
	display: block;
	height: 6px;
	border-radius: 999px;
	background: #e6edf6;
	overflow: hidden;
}
.aq-bar--lg {
	height: 8px;
}
.aq-bar span {
	display: block;
	height: 100%;
	border-radius: inherit;
	background: var(--aq-success);
	transition: width 0.3s var(--aq-ease);
}
.aq-bar--low span {
	background: #e39a1b;
}
.aq-zpm__more {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	margin-top: auto;
	color: var(--aq-primary);
	font-size: 14px;
	font-weight: 600;
}
.aq-pager {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	margin-top: 20px;
}
.aq-pager__info {
	min-width: 60px;
	color: var(--aq-muted);
	text-align: center;
}
.aq-btn--icon {
	width: 44px;
	padding: 0;
}
@media (max-width: 768px) {
	.aq-cards {
		grid-template-columns: minmax(0, 1fr);
	}
	.aq-filters {
		padding: 16px;
	}
	.aq-filters__field {
		max-width: none;
	}
}
</style>
